import './Logo.styled.scss'

export const Logo = () => (
  <div className="logoWrapper">
    <p className="wisey">WISEY</p>
    <div className="studyWrapper">
      <p className="study">STUDY</p>
    </div>
  </div>
)
